const detachTask = (task, ...params) => setTimeout(() => task(...params), 0)
export default detachTask
